"use client";

import {
  setFieldError,
  setFieldValue } from "@/stores";

import { useForm } from "@/hooks";
import { useTranslations } from "@/i18n";
import {
  Fieldset,
  Input,
} from "@vetty/ui";

/**
 * ResetPasswordConfirmPasswordInput Component
 *
 * Confirm password input field for reset password form with validation and error handling.
 * Manages confirm password field state and clears errors on user input.
 */
export const ResetPasswordConfirmPasswordInput = () => {
  const t = useTranslations("resetPassword.form");

  const { errors } = useForm();

  /**
   * Handles confirm password input changes
   * Updates field value and clears any existing errors
   */
  const handleInputChange = (field: string, value: string) => {
    setFieldValue(field, value);
    setFieldError(field, "");
  };

  return (
    <Fieldset
      isError={errors.confirmPassword}
      errorMessage={errors.confirmPassword}
    >
      <Input
        id={"confirm-password"}
        label={t("confirmPassword")}
        type={"password"}
        onChange={(v) => handleInputChange("confirmPassword", v)}
      />
    </Fieldset>
  );
};
